<template>
  <div class="container">
    <span class="country-flag">
      <CountryFlag :country="isoCountry" size="small" rounded />
    </span>
    <div class="contact-data">
      <span class="country-name">
        {{ countryName }}
      </span>
      <div class="telephone-number">
        <a target="_system" :href="'tel:' + telephoneNumber">{{ telephoneNumber }}</a>
      </div>
      <div>
        <a
          target="_system"
          :href="`mailto:${emailAddress}?subject=${$t('contacts[\'Hi On team! I have a question for you\']')}`">
          {{ emailAddress }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CountryFlag from 'vue-country-flag-next';

export interface ContactCardProps {
  id?: string;
  emailAddress: string;
  telephoneNumber: string;
  isoCountry: string;
  countryName: string;
}

export default defineComponent({
  name: 'contact-card',
  components: {
    CountryFlag,
  },
  props: {
    isoCountry: String,
    telephoneNumber: String,
    emailAddress: String,
    countryName: String,
  },
});
</script>
<style lang="scss">
.container {
  padding: 16px 16px 16px 24px;
  max-width: 653px;
  background-color: var(--primary-bg-color);
  display: flex;

  .country-flag {
    margin-right: 1rem;

    .small-flag.rounded {
      border-radius: 50%;
      width: 39px;
      background-position-x: -6.5px;
      transform: scale(0.4);
    }
  }

  .contact-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .country-name {
      font-size: 1rem;
      font-weight: 700;
      margin-bottom: 0.25rem;
    }

    .telephone-number {
      text-align: left;
    }

    div a {
      font-size: 0.875rem;
      color: var(--secondary-color);
    }
  }
}
</style>
